module.exports = __webpack_public_path__ + "static/media/19ю101.119cbe23.webp";